import { useState } from "react";
import { Dialog } from "./Dialog";
import { Kachel, Knopf } from "./Kachel";

/** Eine Handlung einer Ansicht (oberflaeche.md §1.6 Nr. 2): Kachel mit Symbol und genau einem Begriff. */
export interface Handlung {
  symbol: string;
  begriff: string;
  onPress: () => void;
  /** Begriff mit weichem Trennstrich an der Wortfuge (Kachel `fuge`, design/README K96) */
  fuge?: boolean;
}

/**
 * Handlungen einer Ansicht fest unter der Liste (oberflaeche.md §1.6 Nr. 2, Nr. 5 V-26; Referenz `liste__unten`). Wäre der
 * sichtbare Listenbereich sonst niedriger als der höchste Eintrag plus 25 % (Anforderungen K101 (4)), fasst die App die
 * Handlungen von hinten hinter `button` „mehr“ zusammen: die erste bleibt direkt sichtbar, daneben „mehr“, das `dialog` „mehr“
 * mit den übrigen Handlungen unter ihrem bisherigen Namen öffnet. Ob zusammengefasst wird, misst `gestaltung.ts`
 * (`niedrigeHoehe`, Stufe `handlungen` im Attribut `data-k101` der Ansicht); Notruf steht nie hier.
 */
export function Handlungen({ handlungen, raster }: { handlungen: Handlung[]; raster?: string }) {
  const [offen, setOffen] = useState(false);
  const spalten = raster ?? (handlungen.length >= 3 ? "raster--3" : handlungen.length === 2 ? "raster--2" : "raster--1");
  const rest = handlungen.slice(1);
  return (
    <div className={`raster ${spalten} liste__unten handlungen`}>
      {handlungen.map((h, i) => (
        <Kachel key={h.begriff} art="kompakt" symbol={h.symbol} begriff={h.begriff} fuge={h.fuge} onPress={h.onPress}
          className={i > 0 ? "handlungen__rest" : undefined} />
      ))}
      {rest.length ? <Kachel art="kompakt" symbol="mehr" begriff="mehr" className="handlungen__mehr" onPress={() => setOffen(true)} /> : null}
      {rest.length ? (
        <Dialog name="mehr" symbol="mehr" offen={offen} onSchliessen={() => setOffen(false)}>
          <div className="raster raster--2 handlungen__dialog">
            {rest.map((h) => (
              <Kachel key={h.begriff} art="kompakt" symbol={h.symbol} begriff={h.begriff} fuge={h.fuge}
                onPress={() => { setOffen(false); h.onPress(); }} />
            ))}
          </div>
          <div className="knopfreihe">
            <Knopf art="zweit" onPress={() => setOffen(false)}>Schließen</Knopf>
          </div>
        </Dialog>
      ) : null}
    </div>
  );
}
